export default __webpack_public_path__ + "static/media/a4.a57d733e.png";